import React from 'react';
import PropTypes from 'prop-types';
//------------------------------------------------------------------------------------------------
import './style.scss';

const BookmarkProgressBar = ({
  bookmarkProgress,
  isLive,
  containerStyles,
  indicatorStyles,
}) => {
  return (
    <div
      className={`bookmark-progress-bar ${
        isLive ? 'bookmark-progress-bar-shadow' : ''
      }`}
      style={containerStyles}
    >
      <span
        className="bookmark-progress-bar__indicator"
        style={{ width: `${bookmarkProgress}%`, ...indicatorStyles }}
      />
    </div>
  );
};

BookmarkProgressBar.propTypes = {
  bookmarkProgress: PropTypes.number.isRequired,
  isLive: PropTypes.bool,
  containerStyles: PropTypes.object,
  indicatorStyles: PropTypes.object,
};

export default BookmarkProgressBar;
